<div class="trinka-key-features">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title mb-0 text-center ">
                    <h2>{{ title }}</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-lg-11">
                <div class="gt-features">
                    <a *ngFor="let feature of keyFeatures; trackBy: trackByFn"
                       [routerLink]="feature.route"
                       class="gt-wrapper c-card">
                        <img [src]="feature.icon" class="img-fluid" width="70" height="70" [alt]="feature.alt" />
                        <h2 [innerHTML]="feature.title"></h2>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>